import { Link } from 'react-router-dom';

interface NewsArticle {
  id: number;
  title: string;
  excerpt: string;
  image: string;
  date: string;
  category: string;
  game: string;
  views: number;
  slug: string;
}

export default function NewsSection({ articles }: { articles: NewsArticle[] }) {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              最新资讯
            </h2>
            <p className="text-foreground-600 text-sm mt-2">
              电竞行业最新动态、赛事新闻、深度分析一网打尽
            </p>
          </div>
          <Link
            to="/category/news"
            className="text-primary-500 text-sm font-medium hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1"
          >
            查看全部资讯 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {articles.slice(0, 1).map((a) => (
            <Link
              key={a.id}
              to={`/article/${a.slug}`}
              className="group relative rounded-lg overflow-hidden h-[280px] md:h-[340px]"
            >
              <img
                src={a.image}
                alt={a.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-full mb-3">
                  {a.category}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-white mb-2 line-clamp-2">
                  {a.title}
                </h3>
                <p className="text-white/70 text-sm line-clamp-2 mb-3">
                  {a.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-white/50">
                  <span>{a.date}</span>
                  <span>{a.game}</span>
                  <span>{a.views.toLocaleString()} 阅读</span>
                </div>
              </div>
            </Link>
          ))}

          <div className="flex flex-col gap-4">
            {articles.slice(1, 5).map((a) => (
              <Link
                key={a.id}
                to={`/article/${a.slug}`}
                className="group flex gap-4 p-3 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200"
              >
                <div className="w-28 h-20 md:w-32 md:h-24 flex-shrink-0 rounded-md overflow-hidden">
                  <img
                    src={a.image}
                    alt={a.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-xs text-accent-600 font-medium">{a.category}</span>
                    <span className="text-xs text-foreground-400">{a.date}</span>
                  </div>
                  <h4 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-1.5">
                    {a.title}
                  </h4>
                  <p className="text-xs text-foreground-500 line-clamp-1">
                    {a.excerpt}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}